/**
 * SHA-256 файла в hex (64 символа), через нативный Web Crypto SubtleCrypto.
 * Считаем на фронте при загрузке, чтобы бэк переиспользовал хэш референса для
 * реестра `references` (дедуп) без повторного скачивания из S3.
 *
 * `crypto.subtle` доступен только в secure context (https / localhost). В нашем
 * рантайме это всегда так (dev — https-туннель, прод — https), поэтому fallback
 * не нужен. Если контекст всё же небезопасен — возвращаем `undefined` (attachment
 * без хэша), загрузка при этом не падает.
 */
export const computeSha256 = async (file: File): Promise<string | undefined> => {
    if (!globalThis.crypto?.subtle) return undefined;
    const buffer = await file.arrayBuffer();
    const digest = await globalThis.crypto.subtle.digest("SHA-256", buffer);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
};
